import { z } from 'zod';

export const getAssortmentByIdSchema = z.object({
  id: z.string(),
  bindingType: z.number(),
  traderGroupItemID: z.string(),
  traderGroupItemNamePath: z.string(),
  isFromManager: z.boolean(),
  isActive: z.boolean(),
});

export type GetAssortmentByIdResponse = z.infer<typeof getAssortmentByIdSchema>;
